import { useUserStoreHook } from "@/store/modules/user";

/** 用户协议 */
export const USER_LOGIN_AGREEMENT_ID_EN = "673443d5133f70613d7ac18f";
export const USER_LOGIN_AGREEMENT_ID_ZH_TW = "673440e01d9d88613097a62f";
export const USER_LOGIN_AGREEMENT_ID_EN_DEV = "673558545cf3d43995f0111b";
export const USER_LOGIN_AGREEMENT_ID_ZH_TW_DEV = "6735581e819686399c18cc13";
export const USER_LOGIN_AGREEMENT_ID_JP = "673443d5133f70613d7ac18f";
export const USER_LOGIN_AGREEMENT_ID_JP_DEV = "673558545cf3d43995f0111b";
/** 隐私政策 */
export const USER_LOGIN_PRIVACY_POLICY_EN = "67343f1c7383f05a6205b058";
export const USER_LOGIN_PRIVACY_POLICY_ZH_TW = "67343c9b8e1035615c3f8ca6";
export const USER_LOGIN_PRIVACY_POLICY_ZH_TW_DEV = "6735583c8201c33994810486";
export const USER_LOGIN_PRIVACY_POLICY_EN_DEV = "6735586c8201c33994810573";
export const USER_LOGIN_PRIVACY_POLICY_JP = "67343f1c7383f05a6205b058";
export const USER_LOGIN_PRIVACY_POLICY_JP_DEV = "6735586c8201c33994810573";

const isDev = import.meta.env.MODE === "development";

const getAgreementOrPrivacyId = type => {
  const userStore = useUserStoreHook();
  // 获取当前语言和环境
  const { language } = userStore;
  const langMap = {
    en: {
      Agreement: USER_LOGIN_AGREEMENT_ID_EN,
      Privacy: USER_LOGIN_PRIVACY_POLICY_EN,
      devAgreement: USER_LOGIN_AGREEMENT_ID_EN_DEV,
      devPrivacy: USER_LOGIN_PRIVACY_POLICY_EN_DEV
    },
    zh_TW: {
      Agreement: USER_LOGIN_AGREEMENT_ID_ZH_TW,
      Privacy: USER_LOGIN_PRIVACY_POLICY_ZH_TW,
      devAgreement: USER_LOGIN_AGREEMENT_ID_ZH_TW_DEV,
      devPrivacy: USER_LOGIN_PRIVACY_POLICY_ZH_TW_DEV
    },
    zh: {
      Agreement: USER_LOGIN_AGREEMENT_ID_ZH_TW,
      Privacy: USER_LOGIN_PRIVACY_POLICY_ZH_TW,
      devAgreement: USER_LOGIN_AGREEMENT_ID_ZH_TW_DEV,
      devPrivacy: USER_LOGIN_PRIVACY_POLICY_ZH_TW_DEV
    },
    jp: {
      Agreement: USER_LOGIN_AGREEMENT_ID_JP,
      Privacy: USER_LOGIN_PRIVACY_POLICY_JP,
      devAgreement: USER_LOGIN_AGREEMENT_ID_JP_DEV,
      devPrivacy: USER_LOGIN_PRIVACY_POLICY_JP_DEV
    }
  };

  // 默认返回英文版
  const lang = langMap[language] || langMap.en;
  console.log(lang, isDev ? lang[`dev${type}`] : lang[type]);
  return isDev ? lang[`dev${type}`] : lang[type];
};

export const getUserAgreement = () => getAgreementOrPrivacyId("Agreement");
export const getUserPrivacy = () => getAgreementOrPrivacyId("Privacy");
